// extracted by mini-css-extract-plugin
var _1 = "XFqjb";
export { _1 as "summary" }
